import { Divider, ListSubheader } from "@mui/material";

import { sharedStyles } from "../shared.styles";

import { menuSectionLabelNodeStyles as styles } from "./MenuSectionLabelNode.styles";

interface MenuSectionLabelNodeProps {
  titleKey: string;
  isMainMenu?: boolean;
}

export const MenuSectionLabelNode = ({
  titleKey,
  isMainMenu,
}: MenuSectionLabelNodeProps) => {
  return (
    <>
      <ListSubheader
        component={isMainMenu ? "h2" : "h3"}
        data-testid="menu-nav-sectionLabel"
        css={[
          sharedStyles.headerText,
          isMainMenu
            ? sharedStyles.sectionNodeLabelContainer
            : styles.sectionNodeLabelInnerDepth,
        ]}
      >
        {titleKey}
      </ListSubheader>
      {isMainMenu && <Divider data-testid="menu-nav-divider" />}
    </>
  );
};
